import { useLocalSearchParams } from 'expo-router';
import { ProfileScreen } from '@/components/domain/profile/ProfileScreen';

export default function Member() {
  const { userName } = useLocalSearchParams<{ userName: string }>();

  return <ProfileScreen userName={userName} />;
}
